import axios from "axios";
import { getBackendMainUrl } from "@/utils/axios/global";

// Création d'une instance Axios avec une configuration de base
const apiClient = axios.create({
  baseURL: getBackendMainUrl,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000, // 10 secondes
});

// Fonction pour mettre à jour le token dans les headers
export const setAuthToken = (token: string | null) => {
  if (token) {
    apiClient.defaults.headers.common["authorization"] = `Bearer ${token}`;
    localStorage.setItem("authorization", `Bearer ${token}`);
  } else {
    delete apiClient.defaults.headers.common["authorization"];
    localStorage.removeItem("authorization");
  }
};

// Initialisation du token depuis le localStorage
const token = localStorage.getItem("authorization")?.split(" ")[1];
if (token) {
  setAuthToken(token);
}

// Intercepteur pour ajouter le token à chaque requête
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authorization");
    if (token) {
      config.headers.authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs d'authentification
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Redirection vers login si le token est expiré (401)
    if (error.response?.status === 401) {
      setAuthToken(null);
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
